
import styles from './callActions.module.css';

const CallActions = ({
        activeButton,
        containerClassName = "",
        contentClassName = "",
        iconClassName = ""
    }) =>{

    const { actions = {}, label = "", icon = "" } = activeButton;

    return (
        <button className={`${styles.callActionButton} ${containerClassName}`} {...actions}>
            <label className={`${styles.contentLabel} ${contentClassName}`}>
                {label}
            </label>
            <img src={icon} alt={activeButton.label} className={`${styles.icon} ${iconClassName}`} />
        </button>
    )
}

export default CallActions;